import { useEffect, useRef, useState } from "react";

import HttpManager from "../../services/HttpManager";

/*
	¿Sale el botón «Cambiar Promoción» en esta matrícula? Lo dice GET enrollments/{eid}/_cambioPromo (`canChange`): lo deciden el rol y la
	matrícula, no el permiso de Eximir (ese es solo de Supervisión de Caja y dejaría fuera a la Caja del plantel). Cuesta una llamada
	por matrícula con botón posible; el resultado se recuerda mientras la pantalla siga abierta. `recargar()` lo vuelve a preguntar.
*/
export const useCambioPromoAcceso = (campusId: number | null | undefined, enrollmentIds: number[]): { puede: (id: number | null | undefined) => boolean; recargar: () => void } => {
	const [mapa, setMapa] = useState<Record<number, boolean>>({});
	const [version, setVersion] = useState<number>(0);
	const pedidas = useRef<Set<string>>(new Set());
	const clave = enrollmentIds.filter(Boolean).join(",");

	useEffect(() => {
		if (!campusId) return;
		let vigente = true;
		const http = HttpManager.getInstance();
		clave.split(",").filter(Boolean).map(Number).forEach((id) => {
			const k = campusId + ":" + id + ":" + version;
			if (pedidas.current.has(k)) return;
			pedidas.current.add(k);
			http.enrollmentService.getCambioPromo(campusId, id)
				.then((r) => vigente && setMapa((m) => ({ ...m, [id]: !!(r.data.canOpen ?? r.data.canChange) })))
				.catch(() => vigente && setMapa((m) => ({ ...m, [id]: false })));
		});
		return () => { vigente = false; };
	}, [campusId, clave, version]);

	return { puede: (id) => !!id && !!mapa[id], recargar: () => setVersion((v) => v + 1) };
};

export default useCambioPromoAcceso;
